module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-import-csv"
    }
  }, [_vm._v("\n\timport csv\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30ec0ac9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoImportCsv.vue
// module id = 3670
// module chunks = 1